import React, { useState, useContext, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Drawer, ListItem } from '@material-ui/core'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import './ProductCard.css'
import CommonContext from '../../../../product/context/common/commonContext'
import { useFormik } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { dateTimeFormatFunction } from '../../../../product/common/components'
import Timer from '../../../common/timer'
import FavoriteCheckbox from '../../../../product/components/atoms/FavoriteCheckbox'
import moment from 'moment'
// import Timer from '../../../../product/common/timer'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

function AuctionCard(props) {
    const commonContext = useContext(CommonContext)
    const { setSearchValue, allLocations } = commonContext
    const [auction, setAuction] = useState({})

    const history = useHistory()
    const classes = useStyles()

    const [state, setState] = useState({
        bottom: false,
    })

    useEffect(() => {
        setAuction(props.data)
    }, [props.data])

    const formik = useFormik({
        initialValues: {
            auctionid: '',
        },
    })

    const handleRedirectInternal = (path) => {
        history.push(`/${path}`)
        window.scrollTo(0, 0)
    }

    const auctionRedirect = (id) => {
        handleRedirectInternal(`search?auctionid=${id}`)

        // history.push({
        //     pathname: `/search?auctionid=${id}`,
        //     state: auction,
        // })
        // window.scrollTo(0, 0)
    }

    const handleClose = (state) => {
        state(false)
    }

    const handleOpen = (state) => {
        state(true)
    }

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    return (
        <div className="auctionCard d-flex flex-wrap justify-content-between align-items-stretch">
            <div className="auctionCardLt d-flex p-4">
                <div className="acImg">
                    <Link
                        className="noUnderline"
                        to={`search?auctionid=${auction.id}`}
                        id="auction_image"
                    >
                        <img
                            src={`${global.site_url}/uploads/auction/${auction.avatar}`}
                            alt="Live Auction"
                        />
                    </Link>
                </div>
                <div className="acContent">
                    <Link
                        className="noUnderline"
                        to={`search?auctionid=${auction.id}`}
                        id="auction_title"
                    >
                        <h2>{auction.title}</h2>
                    </Link>
                    <div className="ltCntVw">
                        <h6>
                            {`Total lot${auction.projects_count > 1 ? 's' : ''}: ${
                                auction.projects_count
                            }`}
                        </h6>
                    </div>
                    <h6 className="auctionDesc">{auction.description}</h6>
                    {auction.future_active ? (
                        <p className="clsngDt">
                            Starts on:{' '}
                            {moment(auction.date_added).format('MMMM Do YYYY, h:mm:ss A')}
                        </p>
                    ) : (
                        <p className="clsngDt">
                            Closes on:{' '}
                            {moment(auction.date_closed).format('MMMM Do YYYY, h:mm:ss A')}
                        </p>
                    )}
                    {/* <div className="btnCt d-flex align-items-center justify-content-between mt-4">
                        <FavoriteCheckbox
                            watchlisted={auction.watchlistid}
                            project_id={auction.id}
                        />
                        <a href="/registration">Register to Bid</a>
                        <Link to="/" className="actnVwLk">
                            See Auction
                        </Link>
                    </div> */}
                </div>
            </div>
            <div className="acActBtn">
                <div className="acTimer d-flex justify-content-center align-items-center flex-wrap">
                    <span className="timerIcon material-icons-outlined">timer</span>
                    <div className="tmrLn w-100">
                        {props.auctionType == 'upcoming' ? (
                            'STARTS IN'
                        ) : props.auctionType == 'closed' ? (
                            ''
                        ) : (
                            <h6>TIME LEFT</h6>
                        )}
                        {console.log(props.auctionType, 'auctionType')}
                    </div>
                    {auction.date_closed ? (
                        <Timer
                            date_added={auction.date_added}
                            date_closed={auction.date_closed}
                            withText={1}
                            endText={'Time left' + ':'}
                            startText={'Starts in' + ':'}
                            closedText={
                                auction.market_status === 'open'
                                    ? 'Auction Closing'
                                    : 'Auction Closed'
                            }
                        ></Timer>
                    ) : null}
                </div>
                <PrimaryButton
                    id="viewauction_button"
                    label="View Auction"
                    onClick={() => auctionRedirect(auction.id)}
                />
            </div>
        </div>
    )
}

export default AuctionCard
